export default __webpack_public_path__ + "fa98d44e761f855bc7327979c4648225.png";